import { ArrowUpRight } from 'lucide-react'

export function RoomCard({ room, compact = false }) {
  const Icon = room.icon
  return (
    <article className={`room-card room-card--${room.tone} ${compact ? 'room-card--compact' : ''}`}>
      <div className="room-card__icon"><Icon size={23} strokeWidth={1.6} aria-hidden="true" /></div>
      <div>
        <h3>{room.name}</h3>
        <p>{room.description}</p>
      </div>
      <ArrowUpRight className="room-card__arrow" size={18} aria-hidden="true" />
    </article>
  )
}
